module.exports = __webpack_public_path__ + "static/media/BobabarCover.c6f75e5b.jpg";